<script>
import moment from 'moment';

export default {
  components: {},
  props: {
    content: {
      type: Object,
      default() {
        return {
          html: '',
          created_at: '',
        };
      },
    },
    image: {
      type: String,
      required: false,
      default: '',
    },
    forProspect: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    avatar() {
      return this.image
        ? this.image
        : require('@assets/images/placeholder-avatar.png');
    },
  },
  mounted() {},
  methods: {
    dateFormat(date) {
      return moment(date).format('MMM DD [at] hh:mm a');
    },
  },
};
</script>

<template>
  <div class="message-container">
    <div :class="['avatar', { prospect: forProspect }]">
      <BaseThumbnail :image="avatar" />
    </div>
    <div class="message-text-wrapper">
      <template v-if="forProspect">
        <div class="message-text">
          <span v-if="content.type === 'email'" class="email-subject">{{
            content.subject
          }}</span>
          <span>{{ content.message }}</span>
          <BaseButton
            type="button"
            class="btn-clear secondary"
            v-if="content.type === 'email'"
            @click.stop="$emit('reply', content)"
          >
            Reply
          </BaseButton>
        </div>
        <div class="message-timestamp">
          {{ dateFormat(content.date) }}
        </div>
      </template>
      <template v-else>
        <div class="message-text" v-html="content.html"></div>
        <div class="message-timestamp">
          {{ dateFormat(content.created_at) }}
        </div>
      </template>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable selector-pseudo-element-no-unknown

.message-container {
  align-items: center;
  display: flex;
  margin-bottom: 3rem;

  .avatar {
    margin-bottom: 2rem;
    margin-right: 2rem;
    width: 5rem;

    .image-thumbnail {
      margin-right: 0;
      width: 100%;

      ::v-deep img {
        border-radius: $base-border-radius-md;
        height: 5rem;
        object-fit: cover;
        width: 5rem;
      }
    }
    &.prospect {
      align-items: center;
      background: $color-dark-gray-one;
      border-radius: 50%;
      display: flex;
      height: 4rem;
      justify-content: center;
      width: 4rem;
      .image-thumbnail {
        height: 14px;
        margin-right: 0;
        width: 25px;

        ::v-deep img {
          border-radius: $base-border-radius-md;
          height: 100%;
          object-fit: contain;
          width: 100%;
        }
      }
    }
  }

  .message-text-wrapper {
    max-width: 75%;
    min-width: 25%;

    .message-text {
      background-color: $color-off-white;
      border-radius: 8px;
      font-size: 1.4rem;
      font-weight: 600;
      letter-spacing: 0.116667px;
      line-height: 2.5rem;
      margin-bottom: 1rem;
      padding: 2rem;

      ::v-deep p {
        margin-bottom: 0;
        word-break: break-all;
      }

      .email-subject {
        display: block;
        font-weight: 700;
        margin-bottom: 1rem;
      }
    }

    .message-timestamp {
      color: $color-text;
      font-size: 1.2rem;
      font-weight: 800;
      letter-spacing: -0.3px;
      line-height: 0.9rem;
      mix-blend-mode: normal;
      opacity: 0.5;
      padding-left: 1rem;
    }
    .btn-clear {
      background-color: rgba($color-black-wo-rgb, 0.05);
      border-radius: 50px;
      color: $color-black;
      display: block;
      letter-spacing: 0.116667px;
      margin-top: 10px;
      opacity: 0.7;
    }
  }

  &.trainer {
    flex-direction: row-reverse;
    .message-text {
      background-color: $color-primary-alt;
      color: white;
      margin-right: 2rem;
    }
  }

  &.isMe {
    flex-direction: row-reverse;
    .message-text {
      background-color: $color-primary-alt;
      color: white;
      .btn-clear {
        display: none;
      }
    }
    .avatar {
      margin-left: 2rem;
    }
  }
}
</style>
